import React from 'react'
import { HighlightOutlined, CloseOutlined } from '@ant-design/icons'
import Tooltip from 'antd/lib/tooltip'
import styles from '../Prompt.module.less'

type TooltipContentProps = {
    highlightedElement: HTMLElement | null
    applyHighlight: () => void
    removeHighlight: () => void
    cancelHighlight: () => void
}

const TooltipContent: React.FC<TooltipContentProps> = ({
    highlightedElement,
    applyHighlight,
    removeHighlight,
    cancelHighlight,
}) => {
    return (
        <>
            {highlightedElement ? (
                <Tooltip title="Remove Highlight">
                    <CloseOutlined className={styles['cross-icon']} onClick={removeHighlight} />
                </Tooltip>
            ) : (
                <>
                    <Tooltip title="Highlight">
                        <HighlightOutlined
                            className={styles['highlight-icon']}
                            onClick={applyHighlight}
                        />
                    </Tooltip>
                    <Tooltip title="Cancel">
                        <CloseOutlined className={styles['cross-icon']} onClick={cancelHighlight} />
                    </Tooltip>
                </>
            )}
        </>
    )
}

export default TooltipContent
